var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6464 7.02006L5.8535 10.813C5.53852 11.1279 5.7616 11.6665 6.20706 11.6665H13.7928C14.2383 11.6665 14.4614 11.1279 14.1464 10.813L10.3535 7.02006C10.1582 6.8248 9.84166 6.82479 9.6464 7.02006Z",
    fill: "#00A84D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrow);
export default __webpack_public_path__ + "static/media/longArrow.7ba3537dfbe105f57b87c54e1e2c6122.svg";
export { ForwardRef as ReactComponent };